export default {
  contact: {
    badge: "Let's Connect",
    title: 'Ready to Transform Your Fleet Operations?',
    subtitle: "We're here to help you optimize your fleet management with cutting-edge technology and expert support. Let's discuss how we can drive your business forward.",
    badges: {
      freeConsultation: 'Free Consultation',
      customSolutions: 'Custom Solutions',
      expertSupport: 'Expert Support',
    },
    methodTitle: 'Choose Your Preferred Contact Method',
    methodSub: "We're here to help through multiple channels",
    emailUs: 'Email Us',
    dropUsALine: 'Drop us a line anytime',
    weGetBack: "We'll get back to you within 4 hours",
    callUs: 'Call Us',
    giveUsACall: 'Give us a call during business hours',
    businessHours: 'Mon–Fri from 9am to 6pm',
    contactNow: 'Contact Now',
    sendMessage: 'Send Us a Message',
    fillForm: "Fill out the form and we'll get back to you within 4 hours during business hours.",
    messageSent: 'Message sent',
    thanksReachingOut: "Thanks for reaching out. We'll get back to you within 4 hours during business hours.",
    firstName: 'First Name',
    lastName: 'Last Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    companyName: 'Company Name',
    fleetSize: 'Fleet Size',
    subject: 'Subject',
    message: 'Message',
    submit: 'Send Message',
    errorGeneric: 'Something went wrong. Please try again.',
    placeholders: {
      firstName: 'Your first name',
      lastName: 'Your last name',
      email: 'you@company.com',
      phone: '+1 234 567 8900',
      company: 'Your company',
      message: 'Tell us about your needs...',
    },
    subjects: {
      general: 'General Inquiry',
      demo: 'Product Demo',
      pricing: 'Pricing Information',
      support: 'Technical Support',
      partnership: 'Partnership',
      enterprise: 'Enterprise Solution',
    },
    fleetSizes: {
      small: '1-10 vehicles',
      medium: '11-50 vehicles',
      large: '51-100 vehicles',
      xl: '101-500 vehicles',
      xxl: '500+ vehicles',
    },
    whyContactTitle: 'Why Contact Us?',
    whyContactSub: 'Get expert support and tailored solutions',
    bottomCtaTitle: 'Ready to Transform Your Fleet Operations?',
    bottomCtaSub: 'Join 100+ companies that trust Geofleet for their fleet management needs',
    statsHappyCustomers: 'Happy Customers',
    statsUptime: 'Uptime',
    statsSupport: 'Support',
    viewPricingPlans: 'View Pricing Plans',
    contactUsNow: 'Contact Us Now',
    whyContact: {
      strategic: { title: 'Strategic Solutions', description: 'Tailored fleet management strategies for your business' },
      fast: { title: 'Fast Implementation', description: 'Quick setup and onboarding process' },
      expertise: { title: 'Industry Expertise', description: 'Years of experience in fleet optimization' },
      success: { title: 'Proven Success', description: '100+ satisfied customers worldwide' },
    },
    page: {
      eyebrow: "Talk to us",
      title: "Talk to the Geofleet team",
      subtitle: "Tell us about your fleet and we’ll show you how Geofleet can cut costs and late deliveries.",
      nextTitle: "What happens next",
      steps: {
        review: "We review your details and fleet setup.",
        call: "A specialist calls you within 4 business hours.",
        demo: "You get a tailored demo and pricing for your operation.",
      },
      bookDirect: "Or book a call directly",
    },
    form: {
      name: "Full name",
      email: "Work email",
      company: "Company",
      country: "Country",
      phone: "Phone number",
      fleetSize: "How many vehicles?",
      message: "Anything we should know?",
      messagePlaceholder: "Routes, current tools, what you want to fix…",
      optional: "Optional",
      submit: "Get in touch",
      reassurance: "We reply within 4 business hours. No spam, ever.",
      orEmail: "You can also email",
      successTitle: "Thanks, {{name}}!",
      successBody: "We’ve got your details and will call you within 4 business hours. Want to skip the wait?",
      bookNow: "Book a time now",
      jobTitle: "Job title",
      jobTitlePlaceholder: "e.g. Head of Operations",
      jobTitles: {
        founder: "Founder / CEO",
        operations: "Head of Operations",
        fleet: "Fleet Manager",
        logistics: "Logistics Manager",
        dispatch: "Dispatch Lead",
        it: "CTO / IT Head",
        procurement: "Procurement",
      },
      solutions: "What are you looking for?",
      pickAny: "Pick any",
      solutionOptions: {
        route_planning: "Route planning",
        shipment_tracking: "Shipment tracking",
        fleet_management: "Fleet management",
        gps_tracking: "GPS vehicle tracking",
        auto_dispatch: "Auto dispatch & allocation",
        proof_of_delivery: "Proof of delivery",
        driver_app: "Driver app",
        customer_notifications: "Customer tracking & WhatsApp",
        dashcam_safety: "Dashcam & driver safety",
        cash_on_delivery: "Cash on delivery",
        inventory_hubs: "Inventory & hub operations",
        ai_agents: "AI agents & automation",
        analytics: "Reports & analytics",
        integrations: "Integrations & API",
      },
      errors: {
        name: "Please enter your name.",
        email: "Please enter a valid email.",
        phone: "Enter a valid phone number for {{country}}.",
      },
    },
  },
};
